import * as React from "react";
import { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./Login.scss";
import { useMediaQuery, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import lightlogo from "../../Img/light-mode-logo.png";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Try } from "@mui/icons-material";
import usercalls from "../../Axios";
import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";

import AuthLeft from "./AuthLeft";
import AuthHeader from "./AuthHeader";
import Loader from "../Loader";

export default function Verify2fa() {
  const [otpTimer, setOtpTimer] = useState("");
  const [timer, setTimer] = useState(100);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const handleResend = () => {
    setTimer(60);
    // console.log("OTP resend!");
  };

  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  const navigate = useNavigate();
  const location = useLocation();

  const [otp, setOtp] = useState(Array(6).fill(""));
  const path = usercalls();
  const [load, setLoad] = useState(false);

  const joinedString = otp.join("");

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (/^\d?$/.test(value)) {
      // Allow only single digit
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Automatically move to the next input field when a digit is entered
      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    // Move to the previous input field on backspace
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const verify2fa = async () => {
    try {
      setLoad(true);
      const token = location.state;
      const url = `${consts.BackendUrl}/verify2faotp`;
      const payload = {
        secret: joinedString,
      };
      const response = await path.tokenCall({ url, payload, token });
      const result = await response.json();
      if (result.success) {
        setLoad(false);
        window.localStorage.setItem("Rikosta", result?.result?.token);
        toast.success("Logged in successfully");
        setTimeout(() => {
          navigate(`/trade/${consts?.MainPair}`);
        }, 2000);
      } else {
        setOtp(Array(6).fill(""));
        setLoad(false);
        toast.error(result?.message);
      }
    } catch (error) {
      setOtp(Array(6).fill(""));
      console.log("🚀 ~ verify2fa ~ error:", error);
    }
  };
  return (
    <>
      {/* <AuthHeader/> */}

      <div className="register">
        <Loader />
        <Grid
          container
          component="main"
          sx={{
            justifyContent: "center",
            alignItems: "center",
            height: !lg && "100vh",
          }}
          className={!md ? "medium" : ""}
        >
          {lg && (
            <Grid item xs={12} sm={12} md={6} lg={5.5}>
              <AuthLeft />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={6.5}>
            <Grid
              container
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box
                  sx={{
                    my: md && 3,
                    mx: md && 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "15px",
                    justifyContent: "center",
                    margin: "0 auto",
                  }}
                >
                  <Typography
                    component="h1"
                    variant="h5"
                    className="text-center c-accout"
                    sx={{ mt: 1, mb: 3 }}
                  >
                    Sign In to Dreamster-Exchange
                  </Typography>

                  <Box
                    // component="form"
                    // noValidate
                    // onSubmit={handleSubmit}
                    sx={{ mt: 1 }}
                  >
                    <div className="email-name">
                      One Time Password <span className="required"> * </span>
                    </div>
                    <div
                      className="email-fill mt-10 display-1"
                      style={{ width: "320px" }}
                    >
                      {otp.map((digit, index) => (
                        <TextField
                          key={index}
                          id={`otp-input-${index}`}
                          value={digit}
                          onChange={(e) => handleChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          variant="outlined"
                          className="otp-field"
                        />
                      ))}
                    </div>
                    <div className="otp-timer">
                      {timer > 0 ? (
                        <span
                          style={{
                            color: "var(--clr-font)",
                            textDecoration: "underline",
                          }}
                        >
                          Resend in {timer} seconds
                        </span>
                      ) : (
                        <button
                          onClick={handleResend}
                          style={{
                            background: "none",
                            border: "none",
                            color: "var(--clr-font)",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          Resend OTP
                        </button>
                      )}
                    </div>

                    <div className="common-btn">
                      {load ? (
                        <Button type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                          Processing...
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          fullWidth
                          sx={{ mt: 3, mb: 2 }}
                          onClick={() => {
                            verify2fa();
                          }}
                        >
                          Submit
                        </Button>
                      )}
                    </div>

                    <div className="text-center accnt-sign mt-10">
                      <Link to="/register" variant="body2">
                        Don't have an account? <span>Sign Up</span>
                      </Link>
                    </div>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
